export default function(min, max) {
  min = min == null ? 0 : +min;
  max = max == null ? 1 : +max;
  if (arguments.length === 1) max = min, min = 0;
  else max -= min;
  return function() {
    return Math.random() * max + min;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/uniform.js
// module id = C02A
// module chunks = 1